import { uiText } from '@/i18n/interface';

import { toast } from "@/hooks/use-toast";

export const validateSessionForm = (
  finalTitle: string,
  date: string,
  startTime: string,
  endTime: string
): boolean => {
  if (!finalTitle.trim() || !date || !startTime || !endTime) {
    toast({
      title: uiText("Validation Error"),
      description: uiText("Please fill in all required fields."),
      variant: "destructive"
    });
    return false;
  }

  if (startTime >= endTime) {
    toast({
      title: uiText("Validation Error"),
      description: uiText("End time must be after start time."),
      variant: "destructive"
    });
    return false;
  }

  return true;
};
